/**
 * oddit-section-faqs
 * Accordion toggle functionality for FAQ items
 */
(function () {
  'use strict';

  function initFaqSection(sectionEl) {
    if (!sectionEl) return;

    function handleClick(event) {
      var header = event.target.closest('.oddit-section-faqs__item-header');
      if (!header) return;

      var isExpanded = header.getAttribute('aria-expanded') === 'true';
      var answer = header.nextElementSibling;

      /* Close all other items */
      var allHeaders = sectionEl.querySelectorAll('.oddit-section-faqs__item-header');
      allHeaders.forEach(function (otherHeader) {
        if (otherHeader !== header) {
          otherHeader.setAttribute('aria-expanded', 'false');
          var otherAnswer = otherHeader.nextElementSibling;
          if (otherAnswer && otherAnswer.classList.contains('oddit-section-faqs__answer')) {
            otherAnswer.setAttribute('hidden', '');
            otherAnswer.classList.remove('oddit-section-faqs__answer--open');
          }
        }
      });

      /* Guard: answer element must exist and be the correct element */
      if (!answer || !answer.classList.contains('oddit-section-faqs__answer')) return;

      /* Toggle current item */
      if (isExpanded) {
        header.setAttribute('aria-expanded', 'false');
        answer.classList.remove('oddit-section-faqs__answer--open');
        setTimeout(function () {
          answer.setAttribute('hidden', '');
        }, 300);
      } else {
        header.setAttribute('aria-expanded', 'true');
        answer.removeAttribute('hidden');
        /* Force reflow for transition */
        answer.offsetHeight;
        answer.classList.add('oddit-section-faqs__answer--open');
      }
    }

    /* Use event delegation on the section element */
    sectionEl.addEventListener('click', handleClick);

    /* Return cleanup function */
    return function cleanup() {
      sectionEl.removeEventListener('click', handleClick);
    };
  }

  var cleanupMap = new Map();
  var autoKey = 0;

  function getKey(el) {
    return el.id || (el.dataset.faqKey = el.dataset.faqKey || '__faq_' + (autoKey++));
  }

  /* Initialize all FAQ sections on the page */
  function initAll() {
    document.querySelectorAll('.oddit-section-faqs').forEach(function (sectionEl) {
      var key = getKey(sectionEl);
      if (cleanupMap.has(key)) return;
      var cleanup = initFaqSection(sectionEl);
      if (cleanup) {
        cleanupMap.set(key, cleanup);
      }
    });
  }

  initAll();

  /* Theme Editor: re-initialize when a section is loaded */
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.oddit-section-faqs');
    if (!section) return;
    var key = getKey(section);
    if (cleanupMap.has(key)) {
      cleanupMap.get(key)();
      cleanupMap.delete(key);
    }
    var cleanup = initFaqSection(section);
    if (cleanup) {
      cleanupMap.set(key, cleanup);
    }
  });

  /* Theme Editor: clean up when a section is unloaded */
  document.addEventListener('shopify:section:unload', function (event) {
    var section = event.target.querySelector('.oddit-section-faqs');
    if (!section) return;
    var key = getKey(section);
    if (cleanupMap.has(key)) {
      cleanupMap.get(key)();
      cleanupMap.delete(key);
    }
  });
})();